export default "__VITE_ASSET__7e79b6a0__"